<template>
  <div class="gla-summary"
       :class="{ collapsed: !isBottomVisible || !isVisible }"
       v-resize="onResizePage">
    <div class="header-row">
      <el-checkbox-group
          v-if="type === 'gla'"
          size="mini"
          class="checkboxes"
          v-model="filters.shownColumns">
        <el-checkbox
            v-for="(checkbox, index) in showColumnsList"
            :key="index"
            :label="index"
            @change="
              toggleColumns(checkbox.columns, index)
            "
        >
          {{
            checkbox.name(
                filters.shownColumns.some((x) => x === index) ? 'Hide' : 'Show'
            )
          }}
        </el-checkbox>
      </el-checkbox-group>

      <el-select
          v-if="filters.shownColumns.some(val => val === 2)"
          style="margin-left: 20px;"
          v-model="foreignCurrencyId"
          placeholder="Currency"
          @change="changeCurrency">
        <el-option
            v-for="item in currencies"
            :key="item.id"
            :label="item.id"
            :value="item.id">
        </el-option>
      </el-select>
      <!--        <el-checkbox disabled label="Trial Balance View"></el-checkbox>-->
      <!--        <el-checkbox disabled label="Foreign Currency"></el-checkbox>-->
    </div>
    <div class="sub-header-info-row">
      <div v-if="type === 'gla'" class="time-block">
        <div>{{ moment().format('h:mm A') }}</div>
        <div>{{ moment().format('MM/DD/YY') }}</div>
        <div>Accrual Basis</div>
      </div>
      <div class="name-block">
        <div>{{ activeCompanyName }}</div>
        <div v-html="`General Ledger (${ type === 'gla' ? 'Summary' : 'Opening Balance Equity' })`"></div>
      </div>
    </div>
    <div class="grids-wrapper">
      <ag-grid-vue
          v-show="isVisible"
          :class="{ collapsed: !isBottomVisible }"
          class="ag-theme-balham"
          id="myGrid"
          :gridOptions="gridOptions"
          :defaultColDef="defaultColDef"
          :rowData="rowData"
          :treeData="true"
          :icons="icons"
          :animateRows="true"
          :getDataPath="getDataPath"
          :getRowNodeId="getRowNodeId"
          :getRowHeight="getRowHeight"
          :autoGroupColumnDef="autoGroupColumnDef"
          :columnDefs="columnDefs"
          :groupDefaultExpanded="groupDefaultExpanded"
          @grid-ready="onGridReady"
          :pinnedBottomRowData="pinnedBottomRowData"
          :context="context"
          :rowSelection="rowSelection"
          @selection-changed="onSelectionChanged"
          @rowClicked="onRowClicked"
          :rowClassRules="rowClassRules"
      />
      <div v-if="!hideSumRow" class="sum-block-content">
        <div class="sum-block-content__left-side side-content">
          <div class="side-content-col">

            <el-button v-if="isVisible" style="width: 130px;" class="name-button" size="mini">
              {{ $t('general_ledger_incomeStatement') }}
            </el-button>
            <el-button style="width: 130px; margin-left: 0;" class="name-button" size="mini">
              {{ $t('general_ledger_balanceSheet') }}
            </el-button>
          </div>
          <div class="side-content-col">
            <el-button v-if="isVisible" class="icon-button" size="mini" @click="clickIncomeStatements"
                       style="padding: 0 10px; height: 28px;">
              <img
                  class="image-icon"
                  v-if="isBottomVisible"
                  src="@/assets/img/toolbar/maximize.svg"
                  width="12px"
                  alt=""
              />
              <img
                  class="image-icon"
                  v-else
                  src="@/assets/img/toolbar/minimize.svg"
                  width="12px"
                  alt=""
              />
            </el-button>
            <el-button class="icon-button" size="mini" @click="clickBalanceSheet"
                       style="padding: 0 10px; height: 28px; margin-left: 0;">
              <img
                  class="image-icon"
                  v-if="isBottomVisible"
                  src="@/assets/img/toolbar/maximize.svg"
                  width="12px"
                  alt=""
              />
              <img
                  class="image-icon"
                  v-else
                  src="@/assets/img/toolbar/minimize.svg"
                  width="12px"
                  alt=""
              />
            </el-button>
          </div>
          <!--          <div v-if="type === 'gla' && isVisible" class="side-content-col">-->
          <!--            <el-select-->
          <!--                size="mini"-->
          <!--                style="margin-left: 14px"-->
          <!--                v-model="filter.datesType"-->
          <!--                placeholder="Dates"-->
          <!--            >-->
          <!--              <el-option-->
          <!--                  v-for="item in datesTypes"-->
          <!--                  :key="item"-->
          <!--                  :label="item"-->
          <!--                  :value="item"-->
          <!--                  @click.native="selectIncomeStatementQuarter(item)"-->
          <!--              >-->
          <!--              </el-option>-->
          <!--            </el-select>-->
          <!--          </div>-->
          <div v-if="type === 'gla'" class="side-content-col" :style="{paddingLeft: '100px'}"
          >
            <div style="display: flex; align-items: center; gap: 5px;">
              <span style="font-size: 12px;">From</span>
              <el-date-picker
                  v-if="isVisible"
                  ref="datepicker"
                  popper-class="custom-date-picker"
                  size="mini"
                  v-model="filter.dates"
                  class="datepicker"
                  prefix-icon="el-icon-date"
                  type="daterange"
                  align="center"
                  format="d MMM yy"
                  :clearable="false"
                  value-format="timestamp"
                  range-separator="To"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                  @change="setFilter"
                  :picker-options="pickerOptions"
              />
            </div>

            <div class="as-at-datepicker" >
              <span class="t-label"> As At </span>
              <el-date-picker
                  size="mini"
                  format="d MMM yy"
                  class="as-at-datepicker-input"
                  v-model="filter.asAtDate"
                  type="datetime"
                  value-format="timestamp"
                  :picker-options="datepickerSetAsOptions"
                  :clearable="false"
                  @change="setAsAtFilter"
              >
              </el-date-picker>
            </div>
          </div>
          <div v-if="type === 'gla'" class="side-content-col">


            <el-dropdown size="mini">
              <span class="el-dropdown-link">
                Report Action<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item icon="el-icon-monitor" :disabled="!filter.dates || !filter.dates.length"
                                  @click.native="openIncomeStatementModal">View
                </el-dropdown-item>
                <el-dropdown-item icon="el-icon-printer" @click.native="exportData(2, 1)">PDF</el-dropdown-item>
                <el-dropdown-item icon="fas fa-file-excel" @click.native="exportData(1, 1)">XL
                </el-dropdown-item>
                <el-dropdown-item icon="el-icon-s-promotion" @click.native="exportData(3,1)">Email</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>


            <el-dropdown size="mini">
              <span class="el-dropdown-link">
                Report Action<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item icon="el-icon-printer" @click.native="exportData(2, 2)">PDF</el-dropdown-item>
                <el-dropdown-item icon="fas fa-file-excel" @click.native="exportData(1, 2)">XL
                </el-dropdown-item>
                <el-dropdown-item icon="el-icon-s-promotion" @click.native="exportData(3,2)">Email</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>


          </div>
        </div>
        <div :style="{'margin-right': `${endingBalanceMarginRight}px`}"
             class="sum-block-content__right-side side-content">
          <div class="side-content-col">
            <div class="net-current-earnings">
              <span class="t-label"> Net Current Earnings </span>
              <el-button class="button-price" size="mini">
                {{
                  formatPrice(incomeStatement ? incomeStatement.amount : 0)
                }}
              </el-button>
            </div>
            <div class="net-current-earnings">
              <span class="t-label">Equity </span>
              <el-button class="button-price" size="mini">
                {{ formatPrice(balanceSheet ? balanceSheet.amount : 0) }}
              </el-button>
            </div>
          </div>
          <!--          <el-checkbox-group-->
          <!--              v-if="type === 'gla'" class="side-content-col checkboxes"-->
          <!--              v-model="filters.shownColumns">-->
          <!--            <el-checkbox-->
          <!--                v-for="(checkbox, index) in showColumnsList"-->
          <!--                :key="index"-->
          <!--                :label="index"-->
          <!--                @change="-->
          <!--                          toggleColumns(checkbox.columns, checkbox.toHideColumns, index)-->
          <!--                        "-->
          <!--            >-->
          <!--              {{-->
          <!--                checkbox.name(-->
          <!--                    filters.shownColumns.some((x) => x === index) ? "Hide" : "Show"-->
          <!--                )-->
          <!--              }}-->
          <!--            </el-checkbox>-->
          <!--          </el-checkbox-group>-->
        </div>
      </div>
      <ag-grid-vue
          v-show="isBottomVisible"
          :class="{ collapsed: !isVisible }"
          class="ag-theme-balham"
          id="myGrid2"
          :icons="icons"
          :gridOptions="gridOptions2"
          :defaultColDef="defaultColDef"
          :rowData="rowData2"
          :treeData="true"
          :animateRows="true"
          :getDataPath="getDataPath"
          :getRowNodeId="getRowNodeId"
          :getRowHeight="getRowHeight"
          :autoGroupColumnDef="autoGroupColumnDef"
          :columnDefs="columnDefs"
          :groupDefaultExpanded="groupDefaultExpanded"
          @grid-ready="onGridReady2"
          :pinnedBottomRowData="pinnedBottomRowData2"
          :context="context"
          :rowSelection="rowSelection"
          @selection-changed="onSelectionChanged"
          @rowClicked="onRowClicked"
          :rowClassRules="rowClassRules"
      />
      <div
          v-if="!hideBottomSumRow"
          v-show="isVisible"
          class="bottom-sum-blocks-content"
      >
        <div
            v-if="type === 'gla'"
            :style="{ opacity: isBottomVisible ? 1 : 0 }"
            class="bottom-sum-blocks-content__content"
        >
          <div class="side-content">
            <div class="side-content-col">
              <el-button size="mini" class="name-button">
                {{ $t('general_ledger_statementOfCashflows') }}
              </el-button>

              <el-button size="mini" class="name-button" style="margin-left: 0;">
                {{ $t('general_ledger_trialBalance') }}
                <!-- {{
                  formatPrice(
                      trialBalance
                          ? parseInt(trialBalance.credit) -
                          parseInt(trialBalance.debit)
                          : 0
                  )
                }} -->
              </el-button>


            </div>
            <!--            <div class="side-content-col">-->
            <!--              <div class="dates-select">-->
            <!--                <span class="t-label"> Dates </span>-->
            <!--                <el-select-->
            <!--                    size="mini"-->
            <!--                    style="margin-left: 14px"-->
            <!--                    v-model="filter.datesType2"-->
            <!--                    placeholder="Dates"-->
            <!--                >-->
            <!--                  <el-option-->
            <!--                      v-for="item in datesTypes"-->
            <!--                      :key="item"-->
            <!--                      :label="item"-->
            <!--                      :value="item"-->
            <!--                  >-->
            <!--                  </el-option>-->
            <!--                </el-select>-->
            <!--              </div>-->
            <!--              <div class="dates-select">-->
            <!--                <span class="t-label"> Dates </span>-->
            <!--                <el-select-->
            <!--                    size="mini"-->
            <!--                    style="margin-left: 14px"-->
            <!--                    v-model="filter.datesType2"-->
            <!--                    placeholder="Dates"-->
            <!--                >-->
            <!--                  <el-option-->
            <!--                      v-for="item in datesTypes"-->
            <!--                      :key="item"-->
            <!--                      :label="item"-->
            <!--                      :value="item"-->
            <!--                  >-->
            <!--                  </el-option>-->
            <!--                </el-select>-->
            <!--              </div>-->
            <!--            </div>-->
            <div class="side-content-col" :style="{paddingLeft: '100px'}">
              <div class="calendar-select">
                <span class="t-label"> From </span>
                <el-date-picker
                    popper-class="custom-date-picker"
                    size="mini"
                    v-model="filter.dates2"
                    class="datepicker calendar-select-input"
                    prefix-icon="el-icon-date"
                    type="daterange"
                    align="center"
                    format="d MMM yy"
                    :clearable="false"
                    value-format="timestamp"
                    range-separator="To"
                    start-placeholder="Start date"
                    end-placeholder="End date"
                    :picker-options="pickerOptions"
                >
                </el-date-picker>
              </div>
              <div class="calendar-select">
                <span class="t-label"> From </span>
                <el-date-picker
                    popper-class="custom-date-picker"
                    size="mini"
                    v-model="filter.dates3"
                    class="datepicker calendar-select-input"
                    prefix-icon="el-icon-date"
                    type="daterange"
                    align="center"
                    format="d MMM yy"
                    :clearable="false"
                    value-format="timestamp"
                    range-separator="To"
                    start-placeholder="Start date"
                    end-placeholder="End date"
                    :picker-options="pickerOptions"
                >
                </el-date-picker>
              </div>
            </div>
            <div class="side-content-col">
              <el-dropdown size="mini">
              <span class="el-dropdown-link">
                Report Action<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-printer" @click.native="exportData(2, 4)">PDF</el-dropdown-item>
                  <el-dropdown-item icon="fas fa-file-excel" @click.native="exportData(1, 4)">XL
                  </el-dropdown-item>
                  <el-dropdown-item icon="el-icon-s-promotion" @click.native="exportData(3,4)">Email</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown size="mini">
              <span class="el-dropdown-link">
                Report Action<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-printer" @click.native="exportData(2, 3)">PDF</el-dropdown-item>
                  <el-dropdown-item icon="fas fa-file-excel" @click.native="exportData(1, 3)">XL
                  </el-dropdown-item>
                  <el-dropdown-item icon="el-icon-s-promotion" @click.native="exportData(3,3)">Email</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="side-content">
            <div class="side-content-col">
              <div v-if="filters.shownColumns.includes(1)" class="debit-credit-sums"
                   :style="{'right': `${creditMarginRight}px`, 'position': 'absolute', 'bottom': 0}">
                <el-button class="button-price" size="mini">
                  <!-- {{
                    formatPrice(debitSumAmount)
                  }} -->
                  {{
                    formatPrice(
                        trialBalance
                            ? parseInt(trialBalance.debit)
                            : 0
                    )
                  }}
                </el-button>
                <el-button class="button-price" size="mini">
                  <!-- {{
                    formatPrice(creditSumAmount)
                  }} -->
                  {{
                    formatPrice(
                        trialBalance
                            ? parseInt(trialBalance.credit)
                            : 0
                    )
                  }}
                </el-button>
              </div>
              <div class="net-current-earnings"
                   :style="{'right': `${endingBalanceMarginRight}px`, 'position': 'absolute', 'bottom': 0}">
                <span class="t-label"> Out of Balance </span>
                <el-button class="button-price" size="mini">
                  <!-- {{
                    formatPrice(0)
                  }} -->
                  {{
                    formatPrice(
                        trialBalance
                            ? parseInt(trialBalance.credit) -
                            parseInt(trialBalance.debit)
                            : 0
                    )
                  }}
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <c-o-a-add-group-modal
        ref="coaAddGroupModal"
        :cashFlowList="clashflowArr"
        @loadList="loadListAfterCreate"
    />
    <c-o-a-add-class-modal
        ref="coaAddClassModal"
        @loadList="loadListAfterCreate"
    />
    <c-o-a-add-account-modal
        :rowData="rowData"
        :currencyList="currencyList"
        :cashFlowList="clashflowArr"
        ref="coaAddAccountModal"
        @loadList="loadListAfterCreate"
    />
    <c-o-a-add-sub-account-modal
        :currencyList="currencyList"
        :rowData="rowData"
        :cashFlowList="clashflowArr"
        ref="coaAddSubAccountModal"
        @loadList="loadListAfterCreate"
    />
    <opening-cell-renderer
        :currencyList="currencyList"
    />
    <c-o-a-add-account-transaction-modal2
        ref="coaAddAccountTransactionModal2"
        :financialYearStartDate="financialYearStartDate"
        @loadList="loadList"
        @closeModal="closeModal"
    />
    <c-o-a-add-account-transaction-modal3
        ref="coaAddAccountTransactionModal3"
        :financialYearStartDate="financialYearStartDate"
        @loadList="loadList"
        @closeModal="closeModal"
    />
    <c-o-a-add-multi-currency-account-transaction-modal
        v-if="companyLayout"
        :currencyList="currencyList"
        :financialYearStartDate="financialYearStartDate"
        ref="coaAddMultiCurrencyAccountTransactionModal"
        @loadList="loadList"
        @closeModal="closeModal"
    />
    <generall-ledger-detailed-modal
        :startDate="filter.dates[0]"
        :endDate="filter.dates[1]"
        :currencyList="currencyList"
        ref="generallLedgerDetailedModal"
        @loadList="loadList"
        @closeModal="closeModal"
    />
    <g-l-a-organisation
        ref="organisation"
    />
    <c-o-a-add-vendor-client-multi-currency-account-transaction-modal
        v-if="companyLayout"
        :financialYearStartDate="financialYearStartDate"
        :currencyList="currencyList"
        ref="coaAddVendorClientMultiCurrencyAccountTransactionModal"
        @loadList="loadList"
        @closeModal="closeModal"
    />
    <create-tax-account-modal
        ref="createTaxAccountModal"
        @loadList="loadListAfterCreate"
    />
    <assign-tax-account-modal
        ref="assignTaxAccountModal"
        :accounts="taxAccounts"
        @loadList="loadListAfterCreate"
    />
    <general-ledger-income-statement ref="generalLedgerIncomeStatementModal"/>
    <div class=""></div>
    <downloadexcel
        v-show="false"
        ref="downloadexcel"
        class="btn download-excel-button"
        :fetch="uploadExcel"
        :fields="json_fields"
    >
    </downloadexcel>
    <downloadexcel
        v-show="false"
        ref="downloadexcel2"
        class="btn download-excel-button"
        :fetch="uploadBalanceSheetExcel"
        :fields="json_fields2"
    >
    </downloadexcel>
    <downloadexcel
        v-show="false"
        ref="downloadexcel4"
        class="btn download-excel-button"
        :fetch="uploadTrialBalanceExcel"
        :fields="json_fields4"
    >
    </downloadexcel>
  </div>
</template>

<script>
import moment from 'moment'
import { AgGridVue } from 'ag-grid-vue'
import axios from 'axios'
import GLAOrganisation from '@/components/settings/settingsGlAccounts2/glaTabs/GLAOrganisation'
import ActionCellRenderer from '@/components/settings/settingsGlAccounts2/actionCellRenderer.vue'
import COAAddGroupModal from '@/components/settings/settingsGlAccounts2/COAAddGroupModal'
import COAAddClassModal from '@/components/settings/settingsGlAccounts2/COAAddClassModal'
import COAAddAccountModal from '@/components/settings/settingsGlAccounts2/COAAddAccountModal'
import COAAddSubAccountModal from '@/components/settings/settingsGlAccounts2/COAAddSubAccountModal'
import OpeningCellRenderer from '@/components/settings/settingsGlAccounts2/openingCellRenderer'
import DebitCellRenderer from '@/components/settings/settingsGlAccounts2/debitCellRenderer'
import CreditCellRenderer from '@/components/settings/settingsGlAccounts2/creditCellRenderer'
import EndingBalanceCellRenderer from '@/components/settings/settingsGlAccounts2/endingBalanceCellRenderer'
import ForeignBalanceCellRenderer from '@/components/settings/settingsGlAccounts2/foreignBalanceCellRenderer'
import COAAddAccountTransactionModal2
  from '@/components/settings/settingsGlAccounts2/ClientsVendorsSimpleAccount/COAAddAccountTransactionModal2'
import COAAddAccountTransactionModal3
  from '@/components/settings/settingsGlAccounts2/SimpleAccount/COAAddAccountTransactionModal3'
import COAAddMultiCurrencyAccountTransactionModal
  from '@/components/settings/settingsGlAccounts2/MultiCurrencyAccount/COAAddMultiCurrencyAccountTransactionModal'
import GenerallLedgerDetailedModal from '@/components/settings/settingsGlAccounts2/GenerallLedgerDetailedModal'
import COAAddVendorClientMultiCurrencyAccountTransactionModal
  from '@/components/settings/settingsGlAccounts2/ClientsVendorsMultiCurrencyAccount/COAAddVendorClientMultiCurrencyAccountTransactionModal'
import CreateTaxAccountModal from '@/components/settings/settingsGlAccounts2/createTaxAccountModal'
import AssignTaxAccountModal from '@/components/settings/settingsGlAccounts2/assignTaxAccountModal'
import GeneralLedgerIncomeStatement from '@/components/settings/settingsGlAccounts2/GeneralLedgerIncomeStatement'
import downloadexcel from 'vue-json-excel'
import jsPDF from 'jspdf'
import 'jspdf-autotable'

const FASTFOREX_API_KEY = process.env.VUE_APP_FASTFOREX_API_KEY
import resize from 'vue-resize-directive'
import { ObserveVisibility } from 'vue-observe-visibility'

export default {
  name: 'GLASummary',
  props: {
    type: {
      type: String,
      default: 'gla'
    }
  },
  directives: {
    resize,
    'observe-visibility': ObserveVisibility,
  },
  data () {
    return {
      moment: moment,
      doc: [],
      balanceSheetDoc: [],
      trialBalanceDoc: [],
      rowClassRules: null,
      filter: {
        datesType: 'None',
        datesType2: null,
        datesType3: null,
        dates: [],
        dates2: [],
        dates3: [],
        asAtDate: moment(),
      },
      filters: {
        shownColumns: [],
      },
      showColumnsList: [
        {
          columns: ['amount', 'endingBalance'],
          // toHideColumns: [],
          name: () => 'Show Opening',
        },
        {
          columns: ['creditId', 'debit'],
          // toHideColumns: ['endingBalance'],
          name: () => 'Trial Balance View',
        },
        {
          columns: ['currencycode', 'exchangeRate', 'foreignBalance'],
          // toHideColumns: [],
          name: () => 'Foreign Currency',
        },
      ],
      datepickerSetAsOptions: {
        disabledDate: this.disabledDueDate
      },
      datesTypes: ['None', 'This financial quarter', 'Last financial quarter'],
      whatToShowList: [
        { id: 1, name: this.$i18n.t('settings_businessCenters') },
        { id: 2, name: this.$i18n.t('settings_businessUnits') },
        { id: 3, name: this.$i18n.t('settings_warehouses') },
        { id: 4, name: this.$i18n.t('settings_engagements') },
        { id: 5, name: this.$i18n.t('settings_projects') },
        { id: 6, name: this.$i18n.t('settings_employee') },
      ],
      rowData: [],
      rowData2: [],
      allRowData: [],
      gridOptions: null,
      gridOptions2: null,
      getDataPath: null,
      getRowNodeId: null,
      getRowHeight: null,
      autoGroupColumnDef: null,
      columnDefs: null,
      gridColumnApi: null,
      gridColumnApi2: null,
      domLayout: 'autoHeight',
      gridApi: null,
      gridApi2: null,
      defaultColDef: null,
      pinnedBottomRowData: null,
      pinnedBottomRowData2: null,
      groupDefaultExpanded: -1,
      context: null,
      rowSelection: 'multiple',
      currencyList: [],
      LeaderLineOptions: {
        path: 'grid',
        size: 2,
      },
      isVisible: true,
      isBottomVisible: true,
      hideSumRow: false,
      hideBottomSumRow: false,
      clashflowArr: [],
      json_fields: {
        Type: 'type',
        Class: 'class',
        Group: 'group',
        Account: 'account',
        Amount: 'amount',
      },
      json_fields2: {
        Type: 'type',
        Class: 'class',
        Group: 'group',
        Account: 'account',
        Amount: 'amount',
      },
      json_fields4: {
        Type: 'type',
        Class: 'class',
        Group: 'group',
        Account: 'account',
        Credit: 'credit',
        Debit: 'debit',
      },
      isBalanceSheet: false,
      pickerOptions: {
        shortcuts: [
          {
            text: 'This month',
            onClick (picker) {
              const end = moment().endOf('month')
              const start = moment().startOf('month')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: 'Last month',
            onClick (picker) {
              const end = moment().endOf('month').subtract(1, 'months')
              const start = moment().startOf('month').subtract(1, 'months')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: 'Last 3 months',
            onClick (picker) {
              const end = moment().endOf('month').subtract(1, 'months')
              const start = moment().startOf('month').subtract(3, 'months')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: 'This financial quarter',
            onClick (picker) {
              const end = moment().endOf('quarter')
              const start = moment().startOf('quarter')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: 'Last financial quarter',
            onClick (picker) {
              const end = moment().subtract(1, 'quarter').endOf('quarter')
              const start = moment().subtract(1, 'quarter').startOf('quarter')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: 'This financial year',
            onClick (picker) {
              const end = moment().endOf('year')
              const start = moment().startOf('year')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: 'Last financial year',
            onClick (picker) {
              const end = moment().endOf('year').subtract(1, 'year')
              const start = moment().startOf('year').subtract(1, 'year')
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      currencies: [],
      foreignCurrencyId: null,
      icons: {
        groupExpanded:
            '<img src="https://www.ag-grid.com/example-assets/group/contract.png" style="height: 12px; width: 12px;padding-right: 2px"/>',
        groupContracted:
            '<img src="https://www.ag-grid.com/example-assets/group/expand.png" style="height: 12px; width: 12px;padding-right: 2px"/>',
      },
      endingBalanceColumnRightOffset: 0,
      creditColumnRightOffset: 0,
      windowWidth: window.innerWidth
    }
  },
  components: {
    GLAOrganisation,
    GeneralLedgerIncomeStatement,
    downloadexcel,
    AssignTaxAccountModal,
    CreateTaxAccountModal,
    COAAddVendorClientMultiCurrencyAccountTransactionModal,
    COAAddMultiCurrencyAccountTransactionModal,
    GenerallLedgerDetailedModal,
    COAAddAccountTransactionModal3,
    COAAddAccountTransactionModal2,
    COAAddSubAccountModal,
    COAAddAccountModal,
    COAAddClassModal,
    COAAddGroupModal,
    AgGridVue,
    actionCellRenderer: ActionCellRenderer,
    openingCellRenderer: OpeningCellRenderer,
    debitCellRenderer: DebitCellRenderer,
    creditCellRenderer: CreditCellRenderer,
    endingBalanceCellRenderer: EndingBalanceCellRenderer,
    foreignBalanceCellRenderer: ForeignBalanceCellRenderer
  },
  computed: {
    companyLayout () {
      return this.$store.getters.getCompanyLayout
    },
    financialYearStartDate () {
      return this.companyLayout ? this.companyLayout.financialYearStartDate : null
    },
    financialYearStartDateFormatted () {
      // return this.companyLayout && this.companyLayout.financialYearStartDate ? moment(this.companyLayout.financialYearStartDate, 'MM-DD-YYYY').format('YYYY-MM-DD') : null
      return this.companyLayout && this.companyLayout.financialYearStartDate ? moment(this.companyLayout.financialYearStartDate, 'MM-DD-YYYY').format('x') : null
    },
    taxAccounts () {
      return this.rowData.filter(
          (val) => val.entityType === 'account' && val.taxId
      )
    },
    incomeStatement () {
      const statement = this.doc.find(val => val.account === 'NET CURRENT EARNINGS')
      return statement
          ? statement
          : null
    },
    balanceSheet () {
      const balance = this.balanceSheetDoc.find(val => val.type === 'TOTAL EQUITY')
      return balance
          ? balance
          : null
    },
    trialBalance () {
      return this.trialBalanceDoc.length
          ? this.trialBalanceDoc[this.trialBalanceDoc.length - 1]
          : null
    },
    activeCompanyName () {
      return this.$store.state.activeCompanyName
    },
    endingBalanceMarginRight () {
      return this.windowWidth - this.endingBalanceColumnRightOffset - 4
    },
    creditMarginRight () {
      return this.windowWidth - this.creditColumnRightOffset - 4
    },
    exportTypeId () {
      switch (this.type) {
        case 'gla':
          return 5
        case 'opening-equity':
          return null
      }
      return null
    },
    debitSumAmount () {
      return this.allRowData.filter(val => typeof val.debit === 'number').map(val => val.debit).reduce((sum, curr) => sum += curr, 0)
    },
    creditSumAmount () {
      return this.allRowData.filter(val => typeof val.credit === 'number').map(val => val.credit).reduce((sum, curr) => sum += curr, 0)
    }
  },
  beforeMount () {
    this.gridOptions = {
      suppressCellSelection: true,
    }
    this.gridOptions2 = {
      suppressCellSelection: true,
    }
    this.getDataPath = (data) => {
      return data.filePath
    }
    this.getRowNodeId = (data) => {
      return data.id
    }
    this.getRowHeight = (params) => {
      return 30
    }
    this.autoGroupColumnDef = {
      headerName: this.$i18n.t('settings_accountThink_GLAccounts_accountsList'),
      field: 'name',
      suppressMenu: true,
      // width: 110,
      cellRendererParams: {
        suppressCount: true,
        innerRenderer: function (params) {
          return `<span class="account-list-text grid-text">${params.node.data.name}</span>`
        },
      },
      cellClass: 'account-list',
      cellStyle: {
        'border-right-color': '#e2e2e2',
        'padding-left': '10px',
        'align-items': 'center',
        display: 'flex',
      },
    }
    this.columnDefs = [
      {
        suppressSizeToFit: true,
        headerName: this.$i18n.t('settings_accountThink_GLAccounts_dbCode'),
        field: 'code',
        suppressMenu: true,
        width: 90,
        headerClass: 'db-code-header',
        cellClass: 'db-code',
        cellStyle: function (params) {
          return {
            'align-items':
                'center; display: flex; padding-left: 10px; border-right-color: #e2e2e2;',
          }
        },
      },
      {
        suppressSizeToFit: true,
        headerName: this.$i18n.t('settings_accountThink_GLAccounts_accNo'),
        field: 'number',
        cellClass: 'acc-no',
        suppressMenu: true,
        width: 70,
        headerClass: 'acc-no-header center-header',
        cellStyle: {
          'border-right-color': '#e2e2e2',
          'align-items': 'center',
          display: 'flex',
          'justify-content': 'center',
        },
      },
      {
        suppressSizeToFit: true,
        headerName: this.$i18n.t('settings_accountThink_GLAccounts_report'),
        field: 'report',
        headerClass: 'report-header center-header',
        suppressMenu: true,
        width: 75,
        cellStyle: {
          'border-right-color': '#e2e2e2',
          'align-items': 'center',
          display: 'flex',
          'justify-content': 'center',
        },
      },
      {
        suppressSizeToFit: true,
        headerName: 'Opening',
        field: 'amount',
        headerClass: 'opening-header center-header',
        width: 140,
        suppressMenu: true,
        // aggFunc: (params) => {
        //   let result = 0
        //   params.forEach(function (value) {
        //     if (typeof value === 'number') {
        //       console.log(value)
        //       result += value
        //     }
        //   })
        //   return result
        // },
        cellRendererFramework: 'openingCellRenderer',
        cellStyle: {
          'border-right-color': '#e2e2e2',
          'align-items': 'center',
          display: 'flex',
          'justify-content': 'center',
        },
      },
      {
        suppressSizeToFit: true,
        headerName: 'Ending Balance',
        field: 'endingBalance',
        colId: 'endingBalanceId',
        headerClass: 'current-debit-header center-header',
        width: 150,
        suppressMenu: true,
        cellRendererFramework: 'endingBalanceCellRenderer',
        cellStyle: {
          'border-right-color': '#e2e2e2',
          'align-items': 'center',
          display: 'flex',
          'justify-content': 'center',
        },
        // aggFunc: 'sum',
      },
      {
        suppressSizeToFit: true,
        headerName: 'Debit',
        field: 'debit',
        headerClass: 'current-debit-header center-header',
        width: 150,
        suppressMenu: true,
        cellRendererFramework: 'debitCellRenderer',
        cellStyle: {
          'border-right-color': '#e2e2e2',
          'align-items': 'center',
          display: 'flex',
          'justify-content': 'center',
        },
      },
      {
        suppressSizeToFit: true,
        headerName: 'Credit',
        field: 'credit',
        colId: 'creditId',
        headerClass: 'balance-credit-header center-header',
        width: 150,
        suppressMenu: true,
        cellRendererFramework: 'creditCellRenderer',
        cellStyle: {
          'border-right-color': '#e2e2e2',
          'align-items': 'center',
          display: 'flex',
          'justify-content': 'center',
        },
      },
      {
        suppressSizeToFit: true,
        headerName: this.$i18n.t('settings_accountThink_GLAccounts_setAs'),
        field: 'DRCRCode',
        suppressMenu: true,
        headerClass: 'set-as-header center-header',
        width: 50,
        cellClass: 'set-as-cell',
        cellRenderer: function (params) {
          return `<div class="grid-text set-as-text">
                    <span class="dr-text">
                      ${params.node.data.DRCRCode === 'DR' ? 'DR' : ''}
                    </span>
                    <span class="cr-text">
                      ${params.node.data.DRCRCode === 'CR' ? 'CR' : ''}
                    </span>
                  </div>`
        },
        cellStyle: {
          'border-right-color': '#e2e2e2',
          'align-items': 'center',
          display: 'flex',
          'justify-content': 'center',
        },
      },
      {
        suppressSizeToFit: true,
        headerName: this.$i18n.t('settings_accountThink_GLAccounts_tax'),
        headerClass: 'tax-header center-header',
        field: 'nameTax',
        suppressMenu: true,
        width: 100,
        cellStyle: {
          'align-items': 'center',
          display: 'flex',
          'justify-content': 'center',
        },
      },
      {
        suppressSizeToFit: true,
        headerName: this.$i18n.t('settings_accountThink_GLAccounts_currency'),
        field: 'currencycode',
        headerClass: 'currency-header center-header',
        suppressMenu: true,
        width: 70,
        cellStyle: {
          'border-right-color': '#e2e2e2',
          'align-items': 'center',
          display: 'flex',
          'justify-content': 'center',
        },
      },
      {
        suppressSizeToFit: true,
        headerName: 'Cashflow',
        field: 'clashflowObj.name',
        width: 100,
        headerClass: 'type-header center-header',
        suppressMenu: true,
        cellRenderer: function (params) {
          return `<span class="grid-text type-text">${
              params.node.data.clashflowObj
                  ? params.node.data.clashflowObj.name
                  : ''
          }</span>`
        },
        cellStyle: {
          'border-right-color': '#e2e2e2',
          'align-items': 'center',
          display: 'flex',
          'justify-content': 'center',
        },
      },
      {
        suppressSizeToFit: true,
        headerName: 'Exchange rate',
        headerClass: 'tax-header center-header',
        field: 'exchangeRate',
        suppressMenu: true,
        width: 100,
        cellStyle: {
          'align-items': 'center',
          display: 'flex',
          'justify-content': 'center',
        },
      },
      {
        suppressSizeToFit: true,
        headerName: 'Foreign Balance',
        headerClass: 'tax-header center-header',
        field: 'foreignBalance',
        cellRendererFramework: 'foreignBalanceCellRenderer',
        suppressMenu: true,
        width: 150,
        cellStyle: {
          'align-items': 'center',
          display: 'flex',
          'justify-content': 'center',
        },
      },
    ]
    this.defaultColDef = {
      editable: (node) => {
        if (node.colDef.cellClass === 'acc-no') {
          return true
        }
        if (node.colDef.cellClass === 'account-list') {
          return true
        }
      },
      onCellValueChanged: (node) => {
        if (!node.newValue) {
          console.log('node', node)
          return
        }
      },
    }
    this.rowSelection = 'multiple'
    this.context = { componentParent: this }
    this.rowClassRules = {
      'no-access-row': '(!data.active && data.entityType === \'account\')',
    }
  },
  mounted () {
    this.loadCompanyInfo()
    this.getCurrencies()
    this.gridColumnApi = this.gridOptions.columnApi
    this.gridColumnApi2 = this.gridOptions2.columnApi
    this.gridColumnApi.moveColumn('code', 0)
    this.gridColumnApi.moveColumn('number', 1)
    this.gridColumnApi2.moveColumn('code', 0)
    this.gridColumnApi2.moveColumn('number', 1)
    this.gridApi = this.gridOptions.api
    this.gridApi2 = this.gridOptions2.api
    this.gridApi.sizeColumnsToFit()
    this.gridApi2.sizeColumnsToFit()
    // this.$nextTick(() => {
    //   this.moveEndingBalanceSumColumn()
    // })
  },
  methods: {
    tester () {
      console.log('$refs.downloadexcel.$el.click()', this.$refs.downloadexcel.$el.click())
    },
    onGridReady (params) {
      params.api.sizeColumnsToFit()
    },
    onGridReady2 (params) {
      params.api.sizeColumnsToFit()
    },
    loadList (stateStart, stateEnd) {
      console.log(' ==== ', stateStart, stateEnd)
      let start = '2022-01-01'
      if (stateStart) start = moment(stateStart, 'x').format('YYYY-MM-DD')
      if (!stateStart && this.companyLayout.financialYearStartDate) {
        start = moment(this.financialYearStartDateFormatted, 'x').format('YYYY-MM-DD')
      }
      return new Promise((resolve, reject) => {
        const end = stateEnd ? moment(stateEnd, 'x').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
        let loader = this.$loading.show()
        axios.defaults.headers.common['Authorization'] =
            'Bearer ' + sessionStorage.getItem('token')
        axios.defaults.headers.common['X-Timezone-Offset'] = (
            new Date().getTimezoneOffset() / 60
        ).toString()
        axios
            .get(
                `/api/v1/accountDoubleTree/get?companyId=${this.$route.query.companyId}&startDate=${start}&endDate=${end}`
            )
            .then((response) => {
              // change Net Current Earnings from response ))
              const netCurrentEarningIndex = response.data.doubleTree[0].findIndex(val => val.name === 'Net Current Earnings')
              this.rowData = response.data.doubleTree[1].map((val) => ({
                ...val,
                ...{
                  // endingBalance: val.DRCRCode === 'CR' ? val.credit : val.debit,
                  endingBalance: val.endingbalance,
                  exchangeRate: null,
                  foreignBalance: null,
                },
              }))
              console.log('rowData', this.rowData)
              const secondDoubleTree = [...response.data.doubleTree[0]]
              console.log('secondDoubleTree', secondDoubleTree)
              if (netCurrentEarningIndex) secondDoubleTree[netCurrentEarningIndex].endingBalance = Number(this.incomeStatement.amount)
              this.rowData2 = secondDoubleTree.map((val, index) => ({
                ...val,
                ...{
                  // endingBalance: netCurrentEarningIndex === index ? val.endingBalance : val.DRCRCode === 'CR' ? val.credit : val.debit,
                  endingBalance: val.endingbalance,
                  exchangeRate: null,
                  foreignBalance: null,
                },
              }))
              console.log('rowData', this.rowData2)

              // change Net Current Earnings from response ))
              this.allRowData = response.data.doubleTree[1].concat(
                  response.data.doubleTree[0]
              )
              // const hideColumns = [
              //   'credit',
              //   'debit',
              //   'currencycode',
              //   'clashflowObj.name',
              //   'exchangeRate',
              //   'foreignBalance',
              // ]

              // if (this.type === 'gla') hideColumns.push('amount')

              this.showColumnsList.forEach((bal, index) => {
                if (this.type === 'opening-equity' && bal.columns.includes('amount')) return
                this.toggleColumns(bal.columns, index)
              })
              // else {
              //   this.gridColumnApi.setColumnsVisible(hideColumns, false)
              //   this.gridColumnApi2.setColumnsVisible(hideColumns, false)
              // }
              this.gridApi.sizeColumnsToFit()
              this.gridApi2.sizeColumnsToFit()
              loader.hide()
              resolve(response.data)
            })
            .catch((error) => {
              console.log('An error occurred:', error)
              loader.hide()
            })
        this.gridApi.sizeColumnsToFit()
        this.gridApi2.sizeColumnsToFit()
      })
    },
    async loadList2 () {
      try {
        if (this.companyLayout && this.companyLayout.financialYearStartDate) {
          const start = this.financialYearStartDateFormatted ? this.financialYearStartDateFormatted : '2022-01-01'
          const end = moment().format('x')
          this.filter.dates = [
            start,
            end
          ]
          this.downloadDoc(start, end)
          this.downloadBalanceSheetDoc(start, end)
          this.downloadTrialBalanceDoc(start, end)
          this.loadList(start, end)
        }
      } catch (err) {
        console.log(err)
      }
    },
    async loadListAfterCreate ({ entityType, id }) {
      try {
        await this.loadList()
        await this.selectCreatedTask(entityType, id)
      } catch (err) {
        console.log(err)
      }
    },
    closeModal () {
    },
    selectCreatedTask (entityType, id) {
      return new Promise((resolve, reject) => {
        this.gridApi.forEachNode((node, index) => {
          // CHECK IF USER HAVE ACCESS TO TE ROW
          if (node.data.entityType === entityType && node.data.id === id) {
            // MOVE TASK TO MIDDLE CENTER
            this.gridApi.ensureIndexVisible(node.rowIndex, 'middle')
            node.setSelected(true)
            resolve(node)
          }
        })
        this.gridApi2.forEachNode((node, index) => {
          // CHECK IF USER HAVE ACCESS TO TE ROW
          if (node.data.entityType === entityType && node.data.id === id) {
            // MOVE TASK TO MIDDLE CENTER
            this.gridApi2.ensureIndexVisible(node.rowIndex, 'middle')
            node.setSelected(true)
            resolve(node)
          }
        })
      })
    },
    loadCompanyInfo () {
      let loader = this.$loading.show()
      axios.defaults.headers.common['Authorization'] =
          'Bearer ' + sessionStorage.getItem('token')
      axios.defaults.headers.common['X-Timezone-Offset'] = (
          new Date().getTimezoneOffset() / 60
      ).toString()
      axios
          .post(
              `/api/v1/companies/directories?companyId=${this.$route.query.companyId}&operation=create`
          )
          .then((response) => {
            this.currencyList = response.data.currencyList
            loader.hide()
          })
          .catch((error) => {
            console.log('An error occurred:', error)
            loader.hide()
          })
    },
    toggleShowActiveAccountsOnly (val) {
      console.log(val)
    },
    methodFromActionCell (action, params) {
      switch (action) {
        case 'delete':
          return this.deleteNode(params.node.data)
        case 'add':
          if (params.node.data.entityType === 'type')
            return this.$refs.coaAddClassModal.openModal('create', params)
          if (params.node.data.entityType === 'class')
            return this.$refs.coaAddGroupModal.openModal('create', params)
          if (params.node.data.entityType === 'group')
            return this.$refs.coaAddAccountModal.openModal('create', params)
          if (params.node.data.entityType === 'account')
            return this.$refs.coaAddSubAccountModal.openModal('create', params)
          if (params.node.data.entityType === 'sub-account')
            return this.$refs.coaAddSubAccountModal.openModal('create', params)
          break
        case 'update':
          if (params.node.data.entityType === 'class')
            return this.$refs.coaAddClassModal.openModalEdit('update', params)
          if (params.node.data.entityType === 'group')
            return this.$refs.coaAddGroupModal.openModalEdit('update', params)
          if (params.node.data.entityType === 'account')
            return this.$refs.coaAddAccountModal.openModalEdit(
                'update',
                params
            )
          if (params.node.data.entityType === 'sub-account')
            return this.$refs.coaAddSubAccountModal.openModalEdit(
                'update',
                params
            )
          break
        case 'create-tax-account':
          this.$refs.createTaxAccountModal.openModal(params)
          break
        case 'assign-tax':
          this.$refs.assignTaxAccountModal.openModal(params)
          break
      }
    },
    openAccountTransactionModal (params) {
      console.log('params', params)
      // find groups [RECEIVABLES/id-84, ACCOUNTS PAYABLE/id-102]
      console.log(
          'group id',
          params.node.data.filePath[2],
          params.node.data.filePath
      )
      const group = this.allRowData.find(
          (val) =>
              val.id === params.node.data.filePath[2] && val.entityType === 'group'
      )
      console.log(
          'group',
          group,
          params.node.data,
          params.node.data.accountCurrencyId
      )
      if (group.code === '1.1.3' || group.code === '2.1.1') {

        if (
            params.node.data.accountCurrencyId &&
            params.node.data.accountCurrencyId !== this.companyLayout.currency.id
        ) {
          params.node.data.openingamount
              ? this.$refs.coaAddVendorClientMultiCurrencyAccountTransactionModal.openModalEdit(
                  params
              )
              : this.$refs.coaAddVendorClientMultiCurrencyAccountTransactionModal.openModal(
                  params
              )
        } else {
          params.node.data.openingamount
              ? this.$refs.coaAddAccountTransactionModal2.openModalEdit(params)
              : this.$refs.coaAddAccountTransactionModal2.openModal(params)
        }
      } else {
        if (
            params.node.data.accountCurrencyId &&
            params.node.data.accountCurrencyId !== this.companyLayout.currency.id
        ) {
          params.node.data.openingamount
              ? this.$refs.coaAddMultiCurrencyAccountTransactionModal.openModalEdit(
                  params
              )
              : this.$refs.coaAddMultiCurrencyAccountTransactionModal.openModal(
                  params
              )
        } else {
          params.node.data.openingamount
              ? this.$refs.coaAddAccountTransactionModal3.openModalEdit(params)
              : this.$refs.coaAddAccountTransactionModal3.openModal(params)
        }
      }
    },
    openGenerallLedgerDetailedModal (params) {
      // if (params.data.entityType !== 'account') {
      if (params.data.entityType !== 'account' || params.data.isChildren === true) {
        return this.$alert('To view the details of the account, select the account rather than the group, class, etc.', '', {
          confirmButtonText: 'OK',
          type: 'info'
        });
        // To view the details of the account, select the account rather than the group, class, etc.
      }
      this.$refs.generallLedgerDetailedModal.openModal(params);
      // this.$refs.organisation.openModal(params)
    },
    clickIncomeStatements () {
      if (this.isBottomVisible) {
        this.isBottomVisible = false
      } else {
        this.isBottomVisible = true
      }
    },
    selectIncomeStatementQuarter (period) {
      let start = null
      let end = null
      switch (period) {
        case 'This financial quarter':
          end = moment().endOf('quarter').format('YYYY-MM-DD')
          start = moment().startOf('quarter').format('YYYY-MM-DD')
          break
        case 'Last financial quarter':
          end = moment().subtract(1, 'quarter').endOf('quarter')
          start = moment().subtract(1, 'quarter').startOf('quarter')
          break
      }
      this.$refs.generalLedgerIncomeStatementModal.openModal(
          start,
          end,
          'QUARTERLY'
      )
    },
    clickBalanceSheet () {
      if (this.isVisible) {
        // this.liner4.color = 'transparent'
        this.isVisible = false
      } else {
        this.isVisible = true
        // this.liner4.color = 'coral'
      }
    },
    deleteNode (data) {
      let url = null
      switch (data.entityType) {
        case 'class':
          url = `/api/v1/accountClass/delete?classId=${data.id}`
          break
        case 'group':
          url = `/api/v1/accountGroup/delete?groupId=${data.id}`
          break
        case 'account':
        case 'sub-account':
          url = `/api/v1/account/delete?companyId=${this.$route.query.companyId}&accountId=${data.id}`
      }
      console.log('data name', data.name)
      this.$confirm(
          this.$t('settings_accountThink_deleteName', { name: data.name }),
          this.$t('general_warning'),
          {
            confirmButtonText: this.$t('general_ok'),
            cancelButtonText: this.$t('general_cancel'),
            type: 'info',
          }
      ).then(() => {
        let loader = this.$loading.show()
        axios.defaults.headers.common['Authorization'] =
            'Bearer ' + sessionStorage.getItem('token')
        axios.defaults.headers.common['X-Timezone-Offset'] = (
            new Date().getTimezoneOffset() / 60
        ).toString()
        axios
            .get(url)
            .then((response) => {
              this.notification(
                  this.$t('general_success'),
                  this.$t('notification_nodeRemoved', { name: data.name }),
                  'success'
              )
              this.loadList()
              loader.hide()
            })
            .catch((error) => {
              console.log('An error occurred:', error)
              loader.hide()
            })
      })
    },
    notification (title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type,
      })
    },
    onSelectionChanged (api) {
      console.log(api)
    },
    onRowClicked (api) {
    },
    loadGraphicks () {
    },
    onResizePage (val, val2) {
      console.log('val', val, val2)
      this.gridApi.sizeColumnsToFit()
      this.gridApi2.sizeColumnsToFit()
      const endingBalanceColumns = document.querySelectorAll('[col-id="endingBalanceId"]')
      this.endingBalanceColumnRightOffset = endingBalanceColumns[0].getBoundingClientRect().right
      const creditColumns = document.querySelectorAll('[col-id="creditId"]')
      if (creditColumns && creditColumns.length) {
        this.creditColumnRightOffset = creditColumns[0].getBoundingClientRect().right
      }
      // creditId
      this.windowWidth = window.innerWidth
    },
    formatPrice (value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    async uploadExcel () {
      try {
        let loader = this.$loading.show()

        const table = this.doc

        loader.hide()

        return table
      } catch (err) {
        console.log(err)
      }
    },
    async uploadBalanceSheetExcel () {
      try {
        let loader = this.$loading.show()

        const table = this.balanceSheetDoc

        loader.hide()

        return table
      } catch (err) {
        console.log(err)
      }
    },
    async uploadTrialBalanceExcel () {
      try {
        let loader = this.$loading.show()

        const table = this.trialBalanceDoc

        loader.hide()

        return table
      } catch (err) {
        console.log(err)
      }
    },
    downloadDoc (stateStart, stateEnd) {
      const start = stateStart
          ? moment(stateStart, 'x').format('YYYY-MM-DD')
          : this.financialYearStartDateFormatted
              ? moment(this.financialYearStartDateFormatted, 'x').format('YYYY-MM-DD')
              : '2022-01-01'
      const end = stateEnd ? moment(stateEnd, 'x').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
      axios.defaults.headers.common['Authorization'] =
          'Bearer ' + sessionStorage.getItem('token')
      axios.defaults.headers.common['X-Timezone-Offset'] = (
          new Date().getTimezoneOffset() / 60
      ).toString()
      axios
          .get(
              `/api/v1/income-statement/list?companyId=${this.$route.query.companyId}&endDate=${end}&startDate=${start}&typeReport=null`
          )
          .then((response) => {
            this.doc = response.data.list
          })
          .catch((err) => {
            console.log(err)
          })
    },
    downloadBalanceSheetDoc (stateStart, stateEnd) {
      console.log('stateStart', stateStart)
      const start = stateStart
          ? moment(stateStart, 'x').format('YYYY-MM-DD')
          : this.financialYearStartDateFormatted
              ? moment(this.financialYearStartDateFormatted, 'x').format('YYYY-MM-DD')
              : '2022-01-01'
      const end = stateEnd ? moment(stateEnd, 'x').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
      axios.defaults.headers.common['Authorization'] =
          'Bearer ' + sessionStorage.getItem('token')
      axios.defaults.headers.common['X-Timezone-Offset'] = (
          new Date().getTimezoneOffset() / 60
      ).toString()
      axios
          .get(
              `/api/v1/balance-sheet/list?companyId=${this.$route.query.companyId}&endDate=${end}&startDate=${start}`
          )
          .then((response) => {
            this.balanceSheetDoc = response.data.list
          })
          .catch((err) => {
            console.log(err)
          })
    },
    downloadTrialBalanceDoc (stateStart, stateEnd) {
      const start = stateStart
          ? moment(stateStart, 'x').format('YYYY-MM-DD')
          : this.financialYearStartDateFormatted
              ? moment(this.financialYearStartDateFormatted, 'x').format('YYYY-MM-DD')
              : '2022-01-01'
      const end = stateEnd ? moment(stateEnd, 'x').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
      axios.defaults.headers.common['Authorization'] =
          'Bearer ' + sessionStorage.getItem('token')
      axios.defaults.headers.common['X-Timezone-Offset'] = (
          new Date().getTimezoneOffset() / 60
      ).toString()
      axios
          .get(
              `/api/v1/trial-balance/list?companyId=${this.$route.query.companyId}&endDate=${end}&startDate=${start}`
          )
          .then((response) => {
            this.trialBalanceDoc = response.data.list
          })
          .catch((err) => {
            console.log(err)
          })
    },
    async downloadPdf () {
      let loader = this.$loading.show()

      const table = this.doc

      loader.hide()

      let pdfName = `${Math.floor(Date.now() / 1000)}`
      const doc = new jsPDF('l', 'pt', 'a4')
      // doc.text(`${this.results.type.toUpperCase()} Autism Screener`, 15, 10)

      const body = []
      table.forEach((val, index) => {
        const item = [
          val.type,
          val.class,
          val.group,
          val.account,
          val.amount,
          val.sortOrder,
        ]
        body.push(item)
      })

      doc.autoTable({
        bodyStyles: { fontSize: 7 },
        margin: { top: 5, left: 5, right: 5, bottom: 0 },
        head: [['Type', 'Class', 'Group', 'Account', 'Amount']],
        body: body,
      })

      doc.output('dataurlnewwindow')
    },
    async downloadBalanceSheetPdf () {
      let loader = this.$loading.show()

      const table = this.balanceSheetDoc

      loader.hide()

      let pdfName = `${Math.floor(Date.now() / 1000)}`
      const doc = new jsPDF('l', 'pt', 'a4')

      const body = []
      table.forEach((val, index) => {
        const item = [val.type, val.class, val.group, val.account, val.amount]
        body.push(item)
      })

      doc.autoTable({
        bodyStyles: { fontSize: 7 },
        margin: { top: 5, left: 5, right: 5, bottom: 0 },
        head: [['Type', 'Class', 'Group', 'Account', 'Amount']],
        body: body,
      })

      doc.output('dataurlnewwindow')
    },
    async downloadTrialBalancePdf () {
      let loader = this.$loading.show()

      const table = this.trialBalanceDoc

      loader.hide()

      let pdfName = `${Math.floor(Date.now() / 1000)}`
      const doc = new jsPDF('l', 'pt', 'a4')

      const body = []
      table.forEach((val, index) => {
        const item = [
          val.type,
          val.class,
          val.group,
          val.account,
          val.credit,
          val.debit,
          val.amount,
          val.sortOrder,
        ]
        body.push(item)
      })

      doc.autoTable({
        bodyStyles: { fontSize: 7 },
        margin: { top: 5, left: 5, right: 5, bottom: 0 },
        head: [['Type', 'Class', 'Group', 'Account', 'Credit', 'Debit']],
        body: body,
      })

      doc.output('dataurlnewwindow')
    },
    openIncomeStatementModal () {
      const [start, end] = this.filter.dates
      this.$refs.generalLedgerIncomeStatementModal.openModal(start, end)
    },
    setFilter (val) {
      if (!val) {
        this.filter.dates = []
      } else {
        const [start, end] = this.filter.dates
        this.loadList(start, end)
        this.downloadDoc(start, end)
        this.downloadBalanceSheetDoc(start, end)
        this.downloadTrialBalanceDoc(start, end)
        this.filter.asAtDate = this.filter.dates[1]
      }
    },
    setAsAtFilter (val) {
      this.filter.dates = [this.filter.dates[0], Number(val)]
      const [start, end] = this.filter.dates
      this.loadList(start, end)
      this.downloadDoc(start, end)
      this.downloadBalanceSheetDoc(start, end)
      this.downloadTrialBalanceDoc(start, end)
    },
    async toggleColumns (columns, index) {
      const allColumns = this.gridColumnApi.getAllDisplayedColumns().map(col => col.getColId())
      console.log('this.gridColumnApi.getAllDisplayedColumns()', allColumns)
      const visibleColumns = this.gridColumnApi.getAllDisplayedColumns().filter(col => col.visible).map(col => col.getColId())
      const isFind = this.filters.shownColumns.some((x) => x === index)
      if (isFind) {
        this.gridColumnApi.setColumnsVisible(columns, isFind)
        this.gridColumnApi2.setColumnsVisible(columns, isFind)
      } else {
        this.gridColumnApi.setColumnsVisible(columns, isFind)
        this.gridColumnApi2.setColumnsVisible(columns, isFind)
      }
      // this.gridColumnApi.setColumnsVisible(showColumns, !!isFind)
      // this.gridColumnApi.setColumnsVisible(hideColumns, !isFind)
      this.gridApi.sizeColumnsToFit()
      //
      // this.gridColumnApi2.setColumnsVisible(showColumns, !!isFind)
      // this.gridColumnApi2.setColumnsVisible(hideColumns, !isFind)
      this.gridApi2.sizeColumnsToFit()
      setTimeout(() => {
        this.moveEndingBalanceSumColumn()
        this.moveCreditSumColumn()
      }, 400)
    },
    async getCurrencies () {
      try {
        console.log(`[FastForex Currencies Request] URL: https://api.fastforex.io/currencies?api_key=${FASTFOREX_API_KEY}`);
        const { data } = await new Promise((resolve) => {
          resolve({
            data: {
              currencies: {
                "AED": "United Arab Emirates Dirham", 
                "AFN": "Afghan Afghani", 
                "ALL": "Albanian Lek", 
                "AMD": "Armenian Dram", 
                "ANG": "Dutch Guilders", 
                "AOA": "Angolan Kwanza", 
                "ARS": "Argentine Peso", 
                "AUD": "Australian Dollar", 
                "AWG": "Aruban Florin", 
                "AZN": "Azerbaijani Manat", 
                "BAM": "Bosnia-Herzegovina Convertible Mark", 
                "BBD": "Barbadian Dollar", 
                "BDT": "Bangladeshi Taka", 
                "BGN": "Bulgarian Lev", 
                "BHD": "Bahraini Dinar", 
                "BIF": "Burundian Franc", 
                "BMD": "Bermudian Dollar", 
                "BND": "Bruneian Dollar", 
                "BOB": "Bolivian Boliviano", 
                "BRL": "Brazilian Real", 
                "BRX": "Brazilian PTAX", 
                "BSD": "Bahamian Dollar", 
                "BTN": "Bhutanese Ngultrum", 
                "BWP": "Botswanan Pula", 
                "BYN": "Belarusian Ruble", 
                "BZD": "Belizean Dollar", 
                "CAD": "Canadian Dollar", 
                "CDF": "Congolese Franc", 
                "CHF": "Swiss Franc", 
                "CLF": "Chilean Unit of Account UF", 
                "CLP": "Chilean Peso", 
                "CNH": "Chinese Yuan Offshore", 
                "CNY": "Chinese Yuan", 
                "COP": "Colombian Peso", 
                "COU": "Unidad de Valor Real (Colombia)", 
                "CRC": "Costa Rican Colon", 
                "CUP": "Cuban Peso", 
                "CVE": "Cape Verdean Escudo", 
                "CZK": "Czech Republic Koruna", 
                "DJF": "Djiboutian Franc", 
                "DKK": "Danish Krone", 
                "DOP": "Dominican Peso", 
                "DZD": "Algerian Dinar", 
                "EGP": "Egyptian Pound", 
                "ERN": "Eritrean Nakfa", 
                "ETB": "Ethiopian Birr", 
                "EUR": "Euro", 
                "FJD": "Fijian Dollar", 
                "FKP": "Falkland Islands Pound", 
                "GBP": "British Pound Sterling", 
                "GEL": "Georgian Lari", 
                "GHS": "Ghanaian Cedi", 
                "GIP": "Gibraltar Pound", 
                "GMD": "Gambian Dalasi", 
                "GNF": "Guinean Franc", 
                "GTQ": "Guatemalan Quetzal", 
                "GYD": "Guyanaese Dollar", 
                "HKD": "Hong Kong Dollar", 
                "HNL": "Honduran Lempira", 
                "HRK": "Croatian Kuna", 
                "HTG": "Haitian Gourde", 
                "HUF": "Hungarian Forint", 
                "HUX": "Hungarian Forint Official Rate", 
                "IDR": "Indonesian Rupiah", 
                "ILS": "Israeli New Sheqel", 
                "INR": "Indian Rupee", 
                "IQD": "Iraqi Dinar", 
                "IRR": "Iranian Rial", 
                "ISK": "Icelandic Krona", 
                "JMD": "Jamaican Dollar", 
                "JOD": "Jordanian Dinar", 
                "JPY": "Japanese Yen", 
                "KES": "Kenyan Shilling", 
                "KGS": "Kyrgystani Som", 
                "KHR": "Cambodian Riel", 
                "KMF": "Comorian Franc", 
                "KPW": "North Korean Won", 
                "KRW": "South Korean Won", 
                "KWD": "Kuwaiti Dinar", 
                "KYD": "Caymanian Dollar", 
                "KZT": "Kazakhstani Tenge", 
                "LAK": "Laotian Kip", 
                "LBP": "Lebanese Pound", 
                "LKR": "Sri Lankan Rupee", 
                "LRD": "Liberian Dollar", 
                "LSL": "Lesotho Maloti", 
                "LYD": "Libyan Dinar", 
                "MAD": "Moroccan Dirham", 
                "MDL": "Moldovan Leu", 
                "MGA": "Malagasy Ariary", 
                "MKD": "Macedonian Denar", 
                "MMK": "Myanma Kyat", 
                "MNT": "Mongolian Tugrik", 
                "MOP": "Macanese Pataca", 
                "MRU": "Mauritanian Ouguiya", 
                "MUR": "Mauritian Rupee", 
                "MVR": "Maldivian Rufiyaa", 
                "MWK": "Malawian Kwacha", 
                "MXN": "Mexican Peso", 
                "MXV": "Mexican Unidad de Inversion", 
                "MYR": "Malaysian Ringgit", 
                "MZN": "Mozambican Metical", 
                "NAD": "Namibian Dollar", 
                "NGN": "Nigerian Naira", 
                "NIO": "Nicaraguan Cordoba", 
                "NOK": "Norwegian Krone", 
                "NPR": "Nepalese Rupee", 
                "NZD": "New Zealand Dollar", 
                "OMR": "Omani Rial", 
                "PAB": "Panamanian Balboa", 
                "PEN": "Peruvian Nuevo Sol", 
                "PGK": "Papua New Guinean Kina", 
                "PHP": "Philippine Peso", 
                "PKR": "Pakistani Rupee", 
                "PLN": "Polish Zloty", 
                "PYG": "Paraguayan Guarani", 
                "QAR": "Qatari Rial", 
                "RON": "Romanian Leu", 
                "RSD": "Serbian Dinar", 
                "RUB": "Russian Ruble", 
                "RWF": "Rwandan Franc", 
                "SAR": "Saudi Arabian Riyal", 
                "SBD": "Solomon Islands Dollar", 
                "SCR": "Seychellois Rupee", 
                "SDG": "Sudanese Pound", 
                "SEK": "Swedish Krona", 
                "SGD": "Singapore Dollar", 
                "SHP": "Saint Helena Pound", 
                "SLL": "Sierra Leonean Leone", 
                "SOS": "Somali Shilling", 
                "SRD": "Surinamese Dollar", 
                "SSP": "South Sudanese Pound", 
                "STN": "Sao Tomean Dobra", 
                "SVC": "Salvadoran Colon", 
                "SYP": "Syrian Pound", 
                "SZL": "Swazi Emalangeni", 
                "THB": "Thai Baht", 
                "TJS": "Tajikistani Somoni", 
                "TMT": "Turkmenistani Manat", 
                "TND": "Tunisian Dinar", 
                "TOP": "Tongan Pa'anga", 
                "TRY": "Turkish Lira", 
                "TTD": "Trinidad and Tobago Dollar", 
                "TWD": "Taiwan New Dollar", 
                "TZS": "Tanzanian Shilling", 
                "UAH": "Ukrainian Hryvnia", 
                "UGX": "Ugandan Shilling", 
                "USD": "United States Dollar", 
                "UYU": "Uruguayan Peso", 
                "UZS": "Uzbekistan Som", 
                "VES": "Venezuelan Bolivar", 
                "VND": "Vietnamese Dong", 
                "VUV": "Ni-Vanuatu Vatu", 
                "WST": "Samoan Tala", 
                "XAF": "CFA Franc BEAC", 
                "XCD": "East Caribbean Dollar", 
                "XDR": "Special Drawing Rights", 
                "XOF": "CFA Franc BCEAO", 
                "XPF": "CFP Franc", 
                "YER": "Yemeni Rial", 
                "ZAR": "South African Rand", 
                "ZMW": "Zambian Kwacha" 
              }
            }
          })
        })
        console.log('response--', data.currencies)
        for (const key in data.currencies) {
          this.currencies.push({ id: key, name: data.currencies[key] })
        }
      } catch (err) {
        console.log(err)
      }
    },
    async changeCurrency (foreignCurrency) {
      try {
        let loader = this.$loading.show()
        // get uniques currencies
        const uniquesCurrencies = [...new Set(this.allRowData.filter(val => val.currencycode).map(bal => bal.currencycode))]
        const convertedArray = []

        for (let i = 0; i < uniquesCurrencies.length; i++) {
          console.log(`[FastForex FetchOne Request] URL: https://api.fastforex.io/fetch-one?from=${uniquesCurrencies[i]}&to=${foreignCurrency}&api_key=${FASTFOREX_API_KEY}`);
          const { data } = await new Promise((resolve) => {
            resolve({
              data: {
                base: uniquesCurrencies[i],
                result: {
                  [foreignCurrency]: 1
                }
              }
            })
          })
          convertedArray.push(data)
        }

        this.rowData = await this.setForeignCurrencies(this.rowData, convertedArray, foreignCurrency)
        this.rowData2 = await this.setForeignCurrencies(this.rowData2, convertedArray, foreignCurrency)

        loader.hide()
        console.log('foreignCurrency', foreignCurrency)
      } catch (err) {
        console.log(err)
      }
    },
    setForeignCurrencies (rowData, convertedArray, foreignCurrency) {
      console.log('rowData, convertedArray', rowData, convertedArray)
      const rowDataCopy = [...rowData]
      return new Promise((resolve, reject) => {
        convertedArray.map(val => {
          rowDataCopy.forEach(row => {
            if (val.base === row.currencycode) {
              row.exchangeRate = val.result[foreignCurrency]
              row.foreignBalance = row.endingBalance ? row.endingBalance * val.result[foreignCurrency] : 0
            }
          })
        })
        resolve(rowDataCopy)
      })
    },
    disabledDueDate (time) {
      if (this.filter.dates[0]) {
        let start = time.getTime() < Number(moment(this.filter.dates[0]).format('x'))
        if (start) {
          return start
        }
      }
    },
    moveEndingBalanceSumColumn () {
      const endingBalanceColumn = document.querySelector('[col-id="endingBalanceId"]')
      this.endingBalanceColumnRightOffset = endingBalanceColumn.getBoundingClientRect().right
    },
    moveCreditSumColumn () {
      const creditColumns = document.querySelectorAll('[col-id="creditId"]')
      if (creditColumns && creditColumns.length) {
        this.creditColumnRightOffset = creditColumns[0].getBoundingClientRect().right
      }
    },
    parseTimestamp(value) {
      // Проверяем, является ли строкой
      if (typeof value === "string") {
        // Проверяем, содержит ли строка только цифры
        if (/^\d+$/.test(value)) {
            return Number(value); // Преобразуем в число
        }
      }
      // Если не строка с числовым timestamp, возвращаем как есть
      return value;
    },
    async exportData (typeExportId, typeId) {
      let email = null
      try {

        if (typeExportId === 3) {
          const { value } = await this.$prompt('Please input your e-mail', '', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
            inputErrorMessage: 'Invalid Email'
          })
          email = value
        }
        const payload = {
          companyId: +this.$route.query.companyId,
          typeId: typeId,
          typeExportId: typeExportId,
          startDate: this.financialYearStartDateFormatted ? moment(this.financialYearStartDateFormatted, 'x').format('YYYY-MM-DD') : '2022-01-01',
          endDate: moment().format('YYYY-MM-DD'),
          email: email,
          optionalField: {
            name: 'typeReport',
            value: null
          }
        }

        if (typeId === 1) {
          const startDate = this.parseTimestamp(this.filter.dates[0])
          const endDate = this.parseTimestamp(this.filter.dates[1])
          payload.startDate = moment(startDate).format('YYYY-MM-DD')
          payload.endDate = moment(endDate).format('YYYY-MM-DD')
        }
        if (typeId === 2) {
          payload.startDate = moment(this.companyLayout.createCompanyDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
          payload.endDate = moment(this.filter.asAtDate).format('YYYY-MM-DD')
        }

        let loader = this.$loading.show()
        axios.defaults.headers.common['Authorization'] =
            'Bearer ' + sessionStorage.getItem('token')
        axios.defaults.headers.common['X-Timezone-Offset'] = (
            new Date().getTimezoneOffset() / 60
        ).toString()
        const { data } = await axios.post(`/api/v1/export`, payload)
        switch (typeExportId) {
          case 2: // pdf
          case 1: // xl
            window.open(data.file.downloadPath).focus()
            break
        }
        loader.hide()
      } catch (err) {
        console.log(err)
      }
    }
  },
  watch: {
    'companyLayout.financialYearStartDate': {
      handler (val) {
        if (!this.isBalanceSheet) {
          const start = this.financialYearStartDateFormatted ? Number(this.financialYearStartDateFormatted) : '2022-01-01'
          const end = Number(moment().format('x'))
          this.filter.dates = [
            start,
            end
          ]
          this.downloadDoc(start, end)
          this.downloadBalanceSheetDoc(start, end)
          this.downloadTrialBalanceDoc(start, end)
          this.loadList(start, end)
          this.isBalanceSheet = true
        }
      },
      deep: true,
    },
  },
}
</script>

<style lang="less" scoped>
.gla-summary {
  .header-row {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .sub-header-info-row {
    display: flex;

    .time-block {
      font-size: 14px;
      line-height: 1.6;
    }

    .name-block {
      text-align: center;
      flex: 1;
      font-size: 14px;
      line-height: 1.6;
    }
  }

  /deep/ .el-tabs__content {
    background: transparent;
  }

  /deep/ .el-tabs__header {
    .el-tabs__item {
      padding: 0 15px;
    }

    #tab-summary {
      padding-left: 15px;
    }

    #tab-organisation {
      padding-right: 15px;
    }
  }

  /deep/ .el-range-separator {
    width: 30px !important;
  }

  /deep/ .el-input__inner {
    border-bottom: none;
  }

  .grids-wrapper {
    margin-top: 10px;

    #myGrid {
      border: 1px solid #e2e2e2;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      height: 300px;
      min-height: 300px;

      &.collapsed {
        height: calc(100vh - 280px);
      }

      /deep/ .ag-root-wrapper {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }

      /deep/ .center-header {
        .ag-header-cell-label {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      /deep/ .set-as-cell {
        span {
          width: 100%;

          .set-as-text {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .dr-text {
              padding: 0 6px;
              //border-right: 1px solid black;
              box-sizing: border-box;
              min-width: 50%;
              display: flex;
              justify-content: center;
            }

            .cr-text {
              //border-left: 1px solid black;
              box-sizing: border-box;
              min-width: 50%;
              padding: 0 6px;
              display: flex;
              justify-content: center;
              color: red;
            }
          }
        }
      }

      /deep/ .action-wrapper {
        display: flex;

        .btn {
          background-color: #ecf5ff;
          border-color: #d9ecff;
          display: inline-block;
          height: 32px;
          padding: 0 10px;
          line-height: 30px;
          font-size: 12px;
          color: #409eff;
          border-width: 1px;
          border-style: solid;
          border-radius: 4px;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          white-space: nowrap;
          cursor: pointer;

          &.add-btn {
            margin-right: 10px;
          }

          &.edit-btn {
            margin-right: 10px;
          }
        }
      }

      /deep/ .ag-floating-bottom-container {
        width: 100% !important;

        .opening-text,
        .action-wrapper {
          display: none;
        }
      }
    }

    .sum-block-content {
      padding: 10px 0;
      display: flex;
      justify-content: space-between;

      .side-content {
        display: flex;
        gap: 10px;

        &-col {
          gap: 10px;
          display: flex;
          flex-direction: column;

          .icon-button {
            display: flex;
            align-items: center;
            justify-content: center;

            /deep/ span {
              height: 100%;
              display: flex;
            }
          }

          .datepicker {
            width: 270px;

            /deep/ .el-range-separator {
              padding: 0;
            }

            /deep/ .el-range__close-icon {
              display: none;
            }
          }

          .as-at-datepicker {
            display: flex;
            align-self: flex-end;
            justify-content: flex-end;
            align-items: center;
            gap: 10px;
            font-size: 12px;
            color: #606266;

            &-input {
              width: 134px;

              /deep/ .el-input__inner {
                padding-right: 0;
                color: #606266;
              }
            }
          }

          .el-dropdown-link {
            height: 28px;
            font-size: 12px;
            display: flex;
            align-items: center;
            cursor: pointer;
          }
        }
      }

      &__right-side {
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        font-size: 12px;
        gap: 30px !important;

        .side-content-col {
          display: flex;
          flex-direction: column;
          gap: 10px;

          .net-current-earnings {
            display: flex;
            gap: 10px;
            justify-content: flex-end;
            align-items: center;

            .button-price {
              min-width: 100px;
            }
          }

          &.checkboxes {
            /deep/ label {
              height: 28px;
              margin-right: 0;
              font-size: 12px;
              display: flex;
              align-items: center;

              .el-checkbox__label {
                font-size: 12px;
              }
            }
          }
        }
      }
    }

    .bottom-sum-blocks-content {
      padding: 10px 0;

      &__content {
        display: flex;
        justify-content: space-between;

        .side-content {
          display: flex;
          gap: 20px;

          &-col {
            gap: 10px;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;

            .dates-select {
              font-size: 12px;
              display: flex;
              align-items: flex-end;
            }

            .calendar-select {
              font-size: 12px;
              display: flex;
              align-items: center;
              gap: 10px;

              &-input {
                width: 270px;

                /deep/ .el-range-separator {
                  padding: 0;
                }

                /deep/ .el-range__close-icon {
                  display: none;
                }
              }
            }

            .el-dropdown-link {
              height: 28px;
              font-size: 12px;
              display: flex;
              align-items: center;
              cursor: pointer;
            }
          }
        }

        .net-current-earnings {
          display: flex;
          gap: 10px;
          justify-content: flex-end;
          align-items: center;
          font-size: 12px;
          //margin-right: 156px;

          .button-price {
            min-width: 100px;
          }
        }

        .debit-credit-sums {
          .button-price {
            min-width: 100px;

          }
        }
      }
    }

    #myGrid2 {
      border: 1px solid #e2e2e2;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      height: 300px;

      &.collapsed {
        height: calc(100vh - 290px);
      }

      /deep/ .ag-root-wrapper {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }

      /deep/ .ag-header {
        display: none;
      }

      /deep/ .center-header {
        .ag-header-cell-label {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      /deep/ .set-as-cell {
        span {
          width: 100%;

          .set-as-text {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .dr-text {
              padding: 0 6px;
              border-right: 1px solid black;
              box-sizing: border-box;
              min-width: 50%;
              display: flex;
              justify-content: center;
            }

            .cr-text {
              border-left: 1px solid black;
              box-sizing: border-box;
              min-width: 50%;
              padding: 0 6px;
              display: flex;
              justify-content: center;
              color: red;
            }
          }
        }
      }

      /deep/ .action-wrapper {
        display: flex;

        .btn {
          background-color: #ecf5ff;
          border-color: #d9ecff;
          display: inline-block;
          height: 32px;
          padding: 0 10px;
          line-height: 30px;
          font-size: 12px;
          color: #409eff;
          border-width: 1px;
          border-style: solid;
          border-radius: 4px;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          white-space: nowrap;
          cursor: pointer;

          &.add-btn {
            margin-right: 10px;
          }

          &.edit-btn {
            margin-right: 10px;
          }
        }
      }

      /deep/ .ag-floating-bottom-container {
        width: 100% !important;
      }
    }
  }
}

/deep/ .ag-theme-balham .ag-cell.ag-cell-inline-editing {
  height: 100%;

  .ag-input-text-wrapper {
    height: 100%;
  }
}

/deep/ .no-access-row {
  background-color: #efa8b2 !important;
}
</style>
